module.exports = __webpack_public_path__ + "static/media/TC_Logo_Concierge.bf19fd53.png";